export default __webpack_public_path__ + "static/media/shape.912e178b.svg";